export default __webpack_public_path__ + "static/media/wotfard-medium-webfont.fe8ead49.woff2";